import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class TransitionConfirmModal extends Component {
  @service transitionConfirm;
}
